<template>
	<footer id="footer">
		<p>&copy; Balcony Games. All rights reserved.</p>
		<p><a href="/privacy.html">Privacy Policy</a> and <a href="/terms.html">Terms</a></p>
	</footer>
</template>

<script>
export default {
	name: "Footer",
};
</script>
